import { useContext, useEffect } from 'react';
import OlLayerGroup from 'ol/layer/Group';

import MapContext, { MapContextType } from '@/context/MapContext/MapContext';

interface IBaseLayersLoaderProps {
  baseLayersGroup?: OlLayerGroup;
}


// there was a bug where baselayer wouldn load if we dont mount map on layers pane
const BaseLayersLoader = ({ baseLayersGroup }: IBaseLayersLoaderProps) => {
  const mapContext = useContext(MapContext) as MapContextType;

  useEffect(() => {
    if (!mapContext.map || !baseLayersGroup) return;

    const mapLayers = mapContext.map.getLayers();
    if (!mapLayers.getArray().includes(baseLayersGroup)) {
      mapLayers.insertAt(0, baseLayersGroup);
    }
  }, [mapContext.map, baseLayersGroup]);

  return null;
};

export default BaseLayersLoader;
